module.exports = __webpack_public_path__ + "static/media/mexico_icon.c4445ec7.png";